import React from "react";
import "../css/Services.css";

const Services = () => {
  return (
    <div className="services6">

      {/* ================= HERO ================= */}
      <section className="srv6-hero">
        <span className="srv6-tag">SERVICES</span>
        <h1>What We Deliver</h1>
        <p>
          Structured systems designed to support training,
          recovery, and long-term performance.
        </p>
      </section>

      {/* ================= SERVICE STACK ================= */}
      <section className="srv6-stack">

        <div className="stack-item">
          <div className="stack-index">01</div>
          <div className="stack-content">
            <h3>Coached Training</h3>
            <p>
              Supervised sessions with clear intent, load control,
              and form correction built into every workout.
            </p>
          </div>
        </div>

        <div className="stack-item">
          <div className="stack-index">02</div>
          <div className="stack-content">
            <h3>Open Gym Access</h3>
            <p>
              Full access to equipment with structured guidelines
              for safe, effective independent training.
            </p>
          </div>
        </div>

        <div className="stack-item">
          <div className="stack-index">03</div>
          <div className="stack-content">
            <h3>Mobility & Recovery</h3>
            <p>
              Dedicated recovery programming focused on joint health,
              breathing, and nervous system balance.
            </p>
          </div>
        </div>

        <div className="stack-item">
          <div className="stack-index">04</div>
          <div className="stack-content">
            <h3>Performance Tracking</h3>
            <p>
              Simple progress monitoring to track consistency,
              workload trends, and recovery capacity.
            </p>
          </div>
        </div>

      </section>

      {/* ================= SERVICE GRID ================= */}
      <section className="srv6-grid">

        <div className="srv6-box">
          <h4>Personal Coaching</h4>
          <p>1:1 guidance with scheduled assessments.</p>
        </div>

        <div className="srv6-box">
          <h4>Small Group Sessions</h4>
          <p>Limited-size classes with shared structure.</p>
        </div>

        <div className="srv6-box">
          <h4>Movement Screening</h4>
          <p>Baseline checks for mobility and control.</p>
        </div>

        <div className="srv6-box">
          <h4>Recovery Blocks</h4>
          <p>Low-load sessions focused on restoration.</p>
        </div>

        <div className="srv6-box">
          <h4>Strength Cycles</h4>
          <p>Planned progression blocks.</p>
        </div>

        <div className="srv6-box">
          <h4>Conditioning Phases</h4>
          <p>Energy system development.</p>
        </div>

      </section>

      {/* ================= SERVICE FOOTNOTE ================= */}
      <section className="srv6-note">
        <p>
          Services are designed to work together as a system —
          not as isolated offerings.
        </p>
      </section>

    </div>
  );
};

export default Services;
